exports = module.exports = require("../../../../../../css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".dv-border-box-7{position:relative;width:100%;height:100%}.dv-border-box-7 .dv-border-svg-container{position:absolute;top:0;left:0;width:100%;height:100%}.dv-border-box-7 .dv-border-svg-container>polyline{fill:none;stroke-linecap:round}.dv-border-box-7 .dv-bb7-line-width-2{stroke-width:2}.dv-border-box-7 .dv-bb7-line-width-5{stroke-width:5}.dv-border-box-7 .border-box-content{position:relative;width:100%;height:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/postcss-loader!./~/@jiaminghi/data-view/lib/components/borderBox7/src/main.css
// module id = 1078
// module chunks = 45